import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NavigationRequest } from "@schabu/web.core/models";
import { INavigationService } from "@schabu/web.core/services";
import { ObjectUtility, StringUtility } from "@schabu/web.core/utilities";
import { Page } from "enumerations/navigation/page.enum";

@Injectable({
	providedIn: "root"
})
export class NavigationService implements INavigationService<Page> {
	protected router: Router = inject(Router);
	
	constructor() {

	}

	public navigate(request: NavigationRequest<Page>): void {
		let route: string = Page.getDescription(request.pageId);

		if (ObjectUtility.exists(request.routeParameters)) {
			Object.keys(request.routeParameters).forEach((key: string) => {
				route = StringUtility.replace(route, `{${key}}`, request.routeParameters[key]);
			});
		}

		route = route.replaceAll(/\{[a-zA-Z0-9]+\}/g, StringUtility.empty);

		this.router.navigate([route], {
			queryParams: request.queryParameters,
			state: {
				payload: request.payload
			}
		});
	}
}